const files = import.meta.glob('../components/views/cmsstaticcontent/layouts/*.vue');

const templateName = path => path
	.replace('../components/views/', '')
	.replace('.vue', '')
	.split('/')
	.map(part => part.charAt(0).toUpperCase() + part.slice(1))
	.join('');

export default defineNuxtPlugin(nuxtApp => {
	Object.entries(files).forEach(([path, loader]) => {
		nuxtApp.$appData.templates.set(templateName(path), loader);
	});
});
